export default (to, from, next) => {
    if (sessionStorage.getItem("customerInfo") == 'null' || sessionStorage.getItem("customerInfo") == null) {
        next({
            path: '/login',
            query: { redirect: to.fullPath }
        })
    } else {
        next()    
    }
}